module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Update Handle for "), (_vm.report && _vm.report.instagram) ? _c('span', [_vm._v(" @" + _vm._s(_vm.report.instagram))]) : _vm._e()]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-select', {
    attrs: {
      "dense": "",
      "placeholder": "Platform",
      "items": _vm.platforms,
      "error-messages": _vm.$v.updateData.platform.$error && "Platform is required.",
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.platform.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.platform.$touch()
      },
      "change": function($event) {
        return _vm.changePlatform()
      }
    },
    model: {
      value: (_vm.updateData.platform),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "platform", $$v)
      },
      expression: "updateData.platform"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-select', {
    attrs: {
      "dense": "",
      "placeholder": "Handle",
      "items": _vm.viewPlatforms,
      "error-messages": _vm.$v.updateData.handle.$error && "Handle is required.",
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.handle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.handle.$touch()
      }
    },
    model: {
      value: (_vm.updateData.handle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "handle", $$v)
      },
      expression: "updateData.handle"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddb9c16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/EditReportHandleModal.vue
// module id = 2089
// module chunks = 0